import React, { createContext, useContext, useState, useCallback } from 'react'

export type MapType = 'google' | 'baidu'

interface MapContextValue {
    mapType: MapType
    setMapType: (type: MapType) => void
    toggleMapType: () => void
    /** SDK 를 못 불러온 지도. 그 지도 자리에는 안내를 보인다 */
    failedMapType: MapType | null
    setFailedMapType: (type: MapType | null) => void
}

const MapContext = createContext<MapContextValue>({
    mapType: 'google',
    setMapType: () => {},
    toggleMapType: () => {},
    failedMapType: null,
    setFailedMapType: () => {},
})

const STORAGE_KEY = 'preferred_map_type'

export const MapProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [mapType, setMapTypeState] = useState<MapType>(() => {
        const saved = localStorage.getItem(STORAGE_KEY)
        return (saved === 'baidu' ? 'baidu' : 'google') as MapType
    })
    const [failedMapType, setFailedMapType] = useState<MapType | null>(null)

    const setMapType = useCallback((type: MapType) => {
        setMapTypeState(type)
        localStorage.setItem(STORAGE_KEY, type)
    }, [])

    const toggleMapType = useCallback(() => {
        setMapType(mapType === 'google' ? 'baidu' : 'google')
    }, [mapType, setMapType])

    return (
        <MapContext.Provider value={{ mapType, setMapType, toggleMapType, failedMapType, setFailedMapType }}>
            {children}
        </MapContext.Provider>
    )
}

export const useMapType = () => useContext(MapContext)
